

const ReactAppStage = process.env.REACT_APP_API_STAGE;

const dev = {
	API_ENDPOINT_URL:
	ReactAppStage == "Dev"
	  ? "https://apitest.vehiclemall.in/v1/"
		: "https://api.jjvehiclemall.com/v1/",
	BASE_URL: process.env.REACT_APP_BASE_URL || "https://jjvehiclemall.com",
  REFETCH_TIME: ReactAppStage == "Dev" ? 8000 : 2000, //For live server
  };
  
  const prod = {
	API_ENDPOINT_URL:
	  ReactAppStage == "Dev"
		? "https://apitest.vehiclemall.in/v1/"
		  : "https://api.jjvehiclemall.com/v1/",
	BASE_URL: process.env.REACT_APP_BASE_URL || "https://jjvehiclemall.com",
  REFETCH_TIME: ReactAppStage == "Dev" ? 8000 : 2000, //For live server
  };
  
  const test = {
	API_ENDPOINT_URL:
	  ReactAppStage == "Dev"
		? "https://apitest.vehiclemall.in/v1/"
		  : "https://api.jjvehiclemall.com/v1/",
	BASE_URL: process.env.REACT_APP_BASE_URL || "https://jjvehiclemall.com",
  REFETCH_TIME: ReactAppStage == "Dev" ? 8000 : 2000, //For live server
  };



const getEnv = () => {
  switch (process.env.NODE_ENV) {
    case 'development':
      return dev;
    case 'production':
      return prod;
    case 'test':
      return test;
    default:
      break;
  }
};

export const env = getEnv();
